// extracted by mini-css-extract-plugin
export default {"settingsIcon":"start-menu-cont-settings-settings_settingsIcon__dm6fi"};